
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Mail } from "lucide-react";
import { RSVPButton } from "@/components/ui/rsvp-button";
import { UrgencyBadge } from "@/components/event-card/UrgencyBadge";

interface RSVPWelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  hostName: string;
  eventName: string;
  description?: string;
  deadline?: string;
  guestRsvpComplete?: boolean;
  hasRecommendations?: boolean;
}

export const RSVPWelcomeModal = ({ 
  isOpen, 
  onClose, 
  hostName, 
  eventName, 
  description,
  deadline,
  guestRsvpComplete = true,
  hasRecommendations = false
}: RSVPWelcomeModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[90%] sm:max-w-md rounded-lg border-none bg-white shadow-lg p-4 sm:p-6 gap-0 animate-letter-open">
        <div className="flex flex-col items-center justify-center space-y-6">
          <div className="flex items-center justify-center w-full h-40 mb-4 bg-gray-50 rounded-lg">
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-primary/10">
              <Mail className="w-10 h-10 text-primary" />
            </div>
          </div>
          <DialogTitle className="text-xl text-center font-medium">
            {hostName} has invited you to {eventName}!
          </DialogTitle>
          {deadline && (
            <div className="flex justify-center">
              <UrgencyBadge 
                deadline={deadline} 
                label="to RSVP"
                guestRsvpComplete={guestRsvpComplete}
                hasRecommendations={hasRecommendations}
              />
            </div>
          )}
          {description && (
            <DialogDescription className="text-sm text-center text-muted-foreground px-4">
              {description}
            </DialogDescription>
          )}
          <RSVPButton onClick={onClose}>
            Start RSVP
          </RSVPButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
